<template>
  <span class="course-tags-container">
    <span ref="tags" class="course-tags">
      <span class="tag level">{{ levelTag }}</span>
      <span v-for="category in categories" :key="category.id" class="tag category">{{
        category.name
      }}</span>
    </span>
    <span v-if="showExtraCount" class="hidden-tag-count">{{ notVisibleCount }}</span>
  </span>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "CourseTags",
  props: {
    levels: { type: Object, required: true },
    categories: { type: Array, required: true }
  },
  data() {
    return {
      notVisibleCount: this.categories.length,
      showExtraCount: true
    };
  },
  computed: {
    levelTag() {
      const levels = this.levels.eiken;

      const lowestLevel = levels[0];
      const highestLevel = levels[levels.length - 1];

      if (lowestLevel === highestLevel) {
        return highestLevel;
      } else {
        return `${lowestLevel} ~ ${highestLevel}`;
      }
    }
  },
  mounted() {
    const tagsRect = this.$refs.tags.getBoundingClientRect();
    const tags = this.$refs.tags.querySelectorAll(".tag");

    let notVisibleCount = 0;

    tags.forEach(tag => {
      const tagRect = tag.getBoundingClientRect();
      if (tagRect.top !== tagsRect.top) {
        notVisibleCount++;
      }
    });

    this.notVisibleCount = notVisibleCount;

    if (notVisibleCount <= 0) {
      this.showExtraCount = false;
    }
  }
});
</script>

<style lang="scss">
.course-tags-container {
  display: grid;
  grid-template-columns: 1fr minmax(0, max-content);

  .course-tags {
    display: flex;
    flex-wrap: wrap;
    height: 22px;
    overflow: hidden;
    text-align: right;

    .tag {
      border-radius: 4px;
      color: var(--color-secondary);
      font-size: $font-size_xxs;
      font-weight: bold;
      height: 22px;
      padding: $gutter / 4;
      white-space: nowrap;
    }

    .tag:not(:first-child) {
      margin-left: $gutter / 2;
    }

    .tag.level {
      background-color: var(--color-secondary-tertiary-background-light);
    }

    .tag.category {
      background-color: var(--color-primary-alternate-background-light);
    }
  }

  .hidden-tag-count {
    align-self: end;
    border-radius: 4px;
    color: var(--color-secondary);
    font-size: $font-size_xxs;
    font-weight: bold;
    margin-left: $gutter / 2;
    padding: $gutter / 4;
    text-align: right;

    &:before {
      content: "+";
    }
  }
}
</style>
